import { put, takeLatest, call, spawn } from 'redux-saga/effects';
import { professionActions } from '../../../application/actions/profession';

import api from '../../api';

const apiProfession = api(process.env.REACT_APP_PROFESSIONS_API);

export function* fetchProfessions() {
  try {
    const { data } = yield call(apiProfession.get, 'v1/consultar');

    if (data) yield put(professionActions.fetchProfessionsSuccess({ professions: data.items }));
    else yield put(professionActions.fetchProfessionsError());
  } catch (err) {
    console.error('professions saga error:', err);
    yield put(professionActions.fetchProfessionsError());
  }
}

export function* watchFetchProfessions() {
  yield takeLatest(professionActions.fetchProfessions.type, fetchProfessions);
}
/* istanbul ignore next */
export default function* professionSaga() {
  yield spawn(watchFetchProfessions);
}
